module.exports = __webpack_public_path__ + "static/media/15.56397e80.jpg";